import { RepairRequestConfirmField } from './repairRequestConfirmField';
import './repairRequestConfirmField.css';
import { RequestConfirmButtonField } from './requestConfirmButtonField';
import { RepairRequestListInfoType } from '@/types/bodyAndPaint';

interface RepairItemRequestProps {
  isEstimating: boolean;
  info: RepairRequestListInfoType;
  onCorrect: () => void;
  onRequest: () => void;
}
export const RepairItemRequest = ({
  isEstimating,
  info,
  onCorrect,
  onRequest,
}: RepairItemRequestProps) => {
  return (
    <div className={'repair-item-request-field'}>
      <RepairRequestConfirmField info={info} />
      <RequestConfirmButtonField
        onCorrect={onCorrect}
        onRequest={onRequest}
        isEstimating={isEstimating}
      />
    </div>
  );
};
